export const iconFontAwesomeNatureFrog = (
	<i className="fa-solid fa-frog"></i>
);
